import React from "react"
import { Link } from "react-router-dom"
import SEO from "../components/SEO.jsx"

// Proper not-found page (noindex). Used for unknown quote URLs.
export default function NotFound({ title = "Page not found", message = "The page you are looking for does not exist or has moved." }) {
  return (
    <div className="min-h-[60vh] bg-white px-4 pt-32 pb-20">
      <SEO title={`${title} | 2merative`} description={message} path="/404" noindex />
      <div className="mx-auto max-w-xl text-center">
        <p className="text-sm font-semibold uppercase tracking-[0.14em] text-brand-primary">404</p>
        <h1 className="mt-3 text-3xl font-bold tracking-tight text-brand-heading sm:text-4xl">{title}</h1>
        <p className="mt-4 text-brand-textSoft">{message}</p>
        <div className="mt-8 flex justify-center gap-4">
          <Link to="/" className="rounded-full bg-brand-primary px-6 py-3 font-semibold text-white hover:bg-blue-700">
            Back to home
          </Link>
          <Link to="/contact" className="rounded-full border border-brand-border px-6 py-3 font-semibold text-brand-heading hover:bg-brand-bg">
            Contact us
          </Link>
        </div>
      </div>
    </div>
  )
}
